module.exports = __webpack_public_path__ + "static/1_dZfxtEmLDGvNC5L74xHJRg-0d54e98e6e6fa4c20c0756e39b316d3f.png";